import { render, staticRenderFns } from "./shop.component.vue?vue&type=template&id=6971f96b"
import script from "./shop.component.vue?vue&type=script&lang=js"
export * from "./shop.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports